import { Controller } from "@hotwired/stimulus"
import { responseIndicatesSessionExpired, responseRedirectedToLogin } from "../lib/session_expired.mjs"

export default class extends Controller {
  static targets = ["frame", "loading", "error"]

  checkResponse(event) {
    const { fetchResponse } = event.detail
    if (this.sessionExpired(fetchResponse.response)) return
    if (fetchResponse.response.ok && fetchResponse.isHTML) return
    // Turbo does not emit frame-missing for non-HTML proxy/server errors.
    event.preventDefault()
    this.failed()
  }

  missing(event) {
    if (this.sessionExpired(event.detail.response)) return
    event.preventDefault()
    this.failed()
  }

  sessionExpired(response) {
    return responseRedirectedToLogin(response) ||
      responseIndicatesSessionExpired(response.status, name => response.headers.get(name))
  }

  failed(event) {
    event?.preventDefault()
    this.frameTarget.replaceChildren(this.errorTarget.content.cloneNode(true))
  }

  retry() {
    this.frameTarget.replaceChildren(this.loadingTarget.content.cloneNode(true))
    this.frameTarget.reload()
  }
}
